import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { AppCommonsModule } from "src/app/commons/app-commons.module";
import { FileUploadService } from "src/app/commons/kymw02/file-upload/file-upload.service";
import { PlessSharedModule } from "src/app/shared/pless-shared.module";
import { GetClassBuyerIdService } from "../../kymw6900/api-services/get-class-buyer-id";
import { GetExistingGoodsCopyService } from "./api-services/get-existing-goods-copy.service";
import { ImagePhotoDownloadService } from "./api-services/image-photo-download.service";
import { ImagePhotoFileUploadService } from "./api-services/image-photo-file-upload.service";
import { RegistNewGoodsProposalService } from "./api-services/regist-new-goods-proposal.service";
import { RegistNewGoodsProposalGoodsService } from "./api-services/regist-new-goods-proposal-goods.service";
import { UpdateNewGoodsProposalService } from "./api-services/update-new-goods-proposal.service";
import { UpdateSuggestionStatusRecruimentService } from "./api-services/update-suggestion-status-recruiment.service";
import { UpdateSuggestionStatusRejectedService } from "./api-services/update-suggestion-status-rejected.service";
import { KYMW6901ProposalTabComponent } from "./kymw6901-proposal-tab.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AppCommonsModule,
    PlessSharedModule
  ],
  declarations: [KYMW6901ProposalTabComponent],
  providers: [
    FileUploadService,
    GetClassBuyerIdService,
    ImagePhotoFileUploadService,
    ImagePhotoDownloadService,
    UpdateNewGoodsProposalService,
    RegistNewGoodsProposalService,
    RegistNewGoodsProposalGoodsService,
    UpdateSuggestionStatusRecruimentService,
    UpdateSuggestionStatusRejectedService,
    GetExistingGoodsCopyService
  ],
  exports: [
    KYMW6901ProposalTabComponent,
  ]
})
export class KYMW6901ProposalTabModule { }